import { useProfileData } from '../AuthProvider'
import Logo from '../Logo'
import * as style from './style.module.scss'
import { Link } from 'gatsby'
import * as React from 'react'

function Footer() {
  const profile = useProfileData({ optional: true })
  const [isClient, setIsClient] = React.useState(false)

  React.useEffect(() => {
    setIsClient(true)
  }, [])

  return (
    <>
      {isClient && (
        <>
          {profile ? (
            <div className={style.footerContainer}>
              <div className={style.footerContent}>
                <div className={style.footerCompanyDetails}>
                  <div className={style.logoContainer}>
                    <Logo />
                    <p>
                      <a
                        className={style.trademark}
                        href='https://tsdr.uspto.gov/#caseNumber=97266791&caseSearchType=US_APPLICATION&caseType=DEFAULT&searchType=statusSearch'
                      >
                        ™
                      </a>{' '}
                      © 2017-2026
                    </p>
                  </div>
                  <div className={style.linkContainer}>
                    <Link to='/terms'>Terms</Link>
                    <Link to='/privacy'>Privacy</Link>
                  </div>
                </div>
              </div>
            </div>
          ) : (
            <div className={style.footerContainer}>
              <div className={style.footerContent}>
                <div className={style.footerLinks}>
                  <div>
                    <h4>Cities</h4>
                    <ul>
                      <li>
                        <p>
                          <Link to='/search/?indices%5BListings%5D%5Bquery%5D=las%20vegas/'>
                            Las Vegas
                          </Link>
                        </p>
                      </li>
                      <li>
                        <p>
                          <Link to='/search/?indices%5BListings%5D%5Bquery%5D=north%20las%20vegas/'>
                            North Las Vegas
                          </Link>
                        </p>
                      </li>
                      <li>
                        <p>
                          <Link to='/search/?indices%5BListings%5D%5Bquery%5D=henderson/'>
                            Henderson
                          </Link>
                          <span className={style.betaBadge}>Beta</span>
                        </p>
                      </li>
                      <li>
                        <p>
                          Phoenix <span>(Coming soon)</span>
                        </p>
                      </li>
                    </ul>
                  </div>
                  <div className={style.companyLinks}>
                    <ul>
                      <li>
                        <Link
                          className={style.sitterLink}
                          to='/become-a-sitter/'
                        >
                          Become a sitter
                        </Link>
                      </li>
                      <li>
                        <p>
                          <Link to='/blog-posts/'>Resources</Link>
                        </p>
                      </li>
                      <li>
                        <p>
                          <Link to='/careers/'>Careers</Link>
                        </p>
                      </li>
                      <li>
                        <p>
                          <Link to='/about/'>About</Link>
                        </p>
                      </li>
                    </ul>
                  </div>
                </div>
                <div className={style.footerCompanyDetails}>
                  <div className={style.logoContainer}>
                    <Logo />
                    <p>
                      <a
                        className={style.trademark}
                        href='https://tsdr.uspto.gov/#caseNumber=97266791&caseSearchType=US_APPLICATION&caseType=DEFAULT&searchType=statusSearch'
                      >
                        ™
                      </a>{' '}
                      © 2017-2026
                    </p>
                  </div>
                  <div className={style.linkContainer}>
                    <Link to='/terms'>Terms</Link>
                    <Link to='/privacy'>Privacy</Link>
                  </div>
                </div>
              </div>
            </div>
          )}
        </>
      )}
    </>
  )
}

export default Footer
